import * as LoadingModel from "./loading.js"

const loading = LoadingModel.domain.selector

export const selectors = { loading }
